import React, { useEffect, useState } from "react";
import Button from "../../extra/Button";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import Input from "../../extra/Input";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  createCoinPackage,
  updateCoinPackage,
} from "../../store/coinPackage/coinPackage.action";

const CoinPackageDialog = (props) => {
  const { dialogueData } = useSelector((state) => state.dialogue);
  const [mongoId, setMongoId] = useState(0);
  const [name, setName] = useState("");
  const [coins, setCoins] = useState("");
  const [price, setPrice] = useState("");
  const [discount, setDiscount] = useState(0);
  const [description, setDescription] = useState("");
  const [isPopular, setIsPopular] = useState(false);
  const [order, setOrder] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [error, setError] = useState({
    name: "",
    coins: "",
    price: "",
    discount: "",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    setMongoId(dialogueData?._id);
    setName(dialogueData?.name || "");
    setCoins(dialogueData?.coins || "");
    setPrice(dialogueData?.price || "");
    setDiscount(dialogueData?.discount || 0);
    setDescription(dialogueData?.description || "");
    setIsPopular(dialogueData?.isPopular || false);
    setOrder(dialogueData?.order || 0);
    setIsActive(dialogueData?.isActive !== undefined ? dialogueData?.isActive : true);
  }, [dialogueData]);

  const handleSubmit = () => {
    if (!name || !coins || !price) {
      let error = {};
      if (!name) error.name = "Package name is required!";
      if (!coins) error.coins = "Coins amount is required!";
      if (!price) error.price = "Price is required!";

      return setError({ ...error });
    }

    if (discount < 0 || discount > 100) {
      return setError({ ...error, discount: "Discount must be between 0 and 100!" });
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("coins", coins);
    formData.append("price", price);
    formData.append("discount", discount);
    formData.append("description", description);
    formData.append("isPopular", isPopular);
    formData.append("order", order);
    formData.append("isActive", isActive);

    if (mongoId) {
      dispatch(updateCoinPackage(formData, mongoId));
    } else {
      dispatch(createCoinPackage(formData));
    }
    dispatch({ type: CLOSE_DIALOGUE });
  };

  return (
    <div className="mainDialogue fade-in">
      <div className="Dialogue" style={{ maxWidth: "600px" }}>
        <div className="dialogueHeader">
          <div className="headerTitle fw-bold text-white">Coin Package</div>
          <div
            className="closeBtn "
            onClick={() => {
              dispatch({ type: CLOSE_DIALOGUE });
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <div className="dialogueMain" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div className="row">
            <div className="col-12">
              <Input
                label={`Package Name`}
                id={`name`}
                type={`text`}
                value={name}
                placeholder={`e.g., "100 Coins", "Popular Pack"`}
                errorMessage={error.name && error.name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      name: `Package name is required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      name: "",
                    });
                  }
                }}
              />
            </div>
            <div className="col-md-6">
              <Input
                label={`Coins Amount`}
                id={`coins`}
                type={`number`}
                value={coins}
                placeholder={`Enter coins amount`}
                errorMessage={error.coins && error.coins}
                onChange={(e) => {
                  setCoins(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      coins: `Coins amount is required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      coins: "",
                    });
                  }
                }}
              />
            </div>
            <div className="col-md-6">
              <Input
                label={`Price (USD)`}
                id={`price`}
                type={`number`}
                step={`0.01`}
                value={price}
                placeholder={`Enter price in USD (1000 coins = $1)`}
                errorMessage={error.price && error.price}
                onChange={(e) => {
                  setPrice(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      price: `Price is required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      price: "",
                    });
                  }
                }}
              />
            </div>
            <div className="col-md-6">
              <Input
                label={`Discount (%)`}
                id={`discount`}
                type={`number`}
                value={discount}
                placeholder={`Enter discount percentage`}
                errorMessage={error.discount && error.discount}
                onChange={(e) => {
                  const val = parseInt(e.target.value) || 0;
                  setDiscount(val);
                  if (val < 0 || val > 100) {
                    return setError({
                      ...error,
                      discount: `Discount must be between 0 and 100`,
                    });
                  } else {
                    return setError({
                      ...error,
                      discount: "",
                    });
                  }
                }}
              />
            </div>
            <div className="col-md-6">
              <Input
                label={`Display Order`}
                id={`order`}
                type={`number`}
                value={order}
                placeholder={`Enter order number`}
                onChange={(e) => setOrder(parseInt(e.target.value) || 0)}
              />
            </div>
            <div className="col-12">
              <div className="form-group">
                <label className="text-white mb-2">Description (Optional)</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={description}
                  placeholder="Enter package description or benefits"
                  onChange={(e) => setDescription(e.target.value)}
                  style={{
                    backgroundColor: "#2d2d2d",
                    color: "white",
                    border: "1px solid #444",
                    padding: "10px"
                  }}
                />
              </div>
            </div>
            <div className="col-12">
              <div className="form-check" style={{ marginTop: "10px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="isPopular"
                  checked={isPopular}
                  onChange={(e) => setIsPopular(e.target.checked)}
                  style={{ cursor: "pointer" }}
                />
                <label
                  className="form-check-label text-white"
                  htmlFor="isPopular"
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa-solid fa-star text-warning me-2"></i>
                  Mark as Popular Package
                </label>
              </div>
            </div>
            <div className="col-12">
              <div className="form-check" style={{ marginTop: "10px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="isActive"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  style={{ cursor: "pointer" }}
                />
                <label
                  className="form-check-label text-white"
                  htmlFor="isActive"
                  style={{ cursor: "pointer" }}
                >
                  Active
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="dialogueFooter">
          <div className="dialogueBtn">
            {!mongoId ? (
              <>
                <Button
                  btnName={`Submit`}
                  btnColor={`btnBlackPrime text-light`}
                  style={{ borderRadius: "5px", width: "80px" }}
                  newClass={`me-2`}
                  onClick={handleSubmit}
                />
              </>
            ) : (
              <>
                <Button
                  btnName={`Update`}
                  btnColor={`btnBlackPrime text-light`}
                  style={{ borderRadius: "5px", width: "80px" }}
                  newClass={`me-2`}
                  onClick={handleSubmit}
                />
              </>
            )}
            <Button
              btnName={`Close`}
              btnColor="myCustomButton"
              style={{ borderRadius: "5px", width: "80px" }}
              onClick={() => {
                dispatch({ type: CLOSE_DIALOGUE });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { createCoinPackage, updateCoinPackage })(
  CoinPackageDialog
);
